<template>
  <div>
    <v-tabs v-model="tab" active-class="tab-active" background-color="transparent">
      <v-tab class="tab-default" :key="1"> Học sinh</v-tab>
      <v-tab class="tab-default" :key="2"> Giáo viên phụ trách </v-tab>
      <v-tab class="tab-default" :key="3"> Thiết lập </v-tab>
    </v-tabs>
    <v-card :flat="$vuetify.breakpoint.smAndDown">
      <v-tabs-items v-model="tab">
        <v-tab-item :key="1">
          <TabStudent />
        </v-tab-item>
        <v-tab-item :key="2">
          <TabTeacher />
        </v-tab-item>
        <v-tab-item :key="3">
          <TabSettings />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>
<script>
import TabStudent from './tab-student/index.vue'
import TabTeacher from './tab-teacher/index.vue'
import TabSettings from './tab-settings/index.vue'
export default {
  components: { TabStudent, TabTeacher, TabSettings },
  data: () => ({ tab: null }),
}
</script>